<svelte:options tag="w-list"/>
<script>
    import Banner from './Banner.svelte';
    import Card from './Card.svelte';

    export let nominations = [];
    export let loaded = false;

    const loading = process.env === 'production'?`${myurl}/images/loading.gif`:"./images/loading.gif";
    const banners = ['75909', '75910', '75911', '75962', '75963', '75939', '75940', '75941', '75942', '75958', '75959', '75960', '75961'];
    let count = -1;

    function increment() {
        count++;
        if (count > banners.length - 1) count = 0;
        return banners[count];
    }

    function returnNada() { return ''}
</script>
{#if nominations.length > 0}
    {#each nominations as nomination, i}
        {#if i % 4 == 0}
            <div class="clearfix"></div>
            {#if i > 0}
                <Banner bannerId={increment()} />
            {/if}
        {/if}
        <Card {nomination} />
    {/each}
{:else}
    {#if loaded }
        <p class="nores">No hay resultados</p>
    {:else}
        <div class="row">
            <div class="col-sm-12 text-center"><img class="loading" src="{loading}" alt="loading..."></div>
        </div>
    {/if}
{/if}

<style>
    img.loading {
        width: 200px;
    }
</style>